import HolidayOrPolicyView from './CalendarHolidayView';
export default HolidayOrPolicyView;
